const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export function family(p) {
  const s = normalize(p.title);
  const t = normalize(p.type);
  if (/jonc|bracelet|collier|sautoir|bague|boucles/.test(s)) return 'jewelry';
  if (/foulard|etole|bandana|casquette|ceinture|sac\b|bonnet|echarpe/.test(s) && !/pull|sweat/.test(s)) return 'accessory';
  if (/botte|bottine|santiag|santiago|mule|sandale|basket|chaussure|mocassin/.test(s+' '+t)) return 'shoe';
  if (/combinaison|combi-short/.test(s)) return 'dress';
  if (/^robe\b/.test(s)) return 'dress';
  if (/veste|manteau|trench|polaire|sherpa|k-way|kway|coupe-vent|impermeable|matelasse/.test(s)) return 'outer';
  if (/^jean\b|^pantalon\b|^jupe\b|^short\b|^bermuda\b/.test(s)) return 'bottom';
  if (/^sweat\b|^mariniere\b/.test(s)) return 'top';
  if (/^pull\b|mohair|maille/.test(s)) return 'knit';
  if (/top|body|bodies|chemise|blouse|t-shirt|tee-shirt|debardeur|gilet/.test(s+' '+t)) return 'top';
  if(t && t!==s) return family({title:p.type,type:''});
  return 'unknown';
}
function subtype(p) {
  const s=normalize(p.title);
  return s.match(/jean|pantalon|jupe|short|bermuda|combinaison|robe|pull|gilet|sweat|mariniere|veste|trench|foulard|etole|botte|mule|santiag/)?.[0] || family(p);
}
const complementary = {
  top:['bottom','outer','shoe','accessory'], knit:['bottom','outer','shoe','accessory'],
  bottom:['knit','top','shoe','accessory'], outer:['knit','bottom','shoe','accessory'],
  dress:['outer','knit','shoe','accessory'], shoe:['bottom','knit','outer','accessory'],
  accessory:['knit','bottom','outer','shoe']
};
function colors(p) { return (normalize(p.title).match(/chocolat|marron|camel|taupe|beige|ecru|ivoire|noir|blanc|gris|marine|bleu|bordeaux|prune|rose|fuchsia|kaki|jaune/g) || []).map(c=>({chocolat:'marron',ivoire:'ecru'}[c]||c)); }
function score(source,p,kind) {
  const a=colors(source), b=colors(p);
  let n = a.some(c=>b.includes(c)) ? 16 : b.some(c=>['ecru','beige','noir','blanc','gris'].includes(c)) ? 6 : 0;
  if(kind==='similaires' && subtype(source)===subtype(p)) n+=40;
  if(kind==='look' && ['knit','outer','top'].includes(family(source)) && /^(jean|pantalon)\b/.test(normalize(p.title))) n+=20;
  if(kind==='look' && ['knit','outer'].includes(family(source)) && /^(short|bermuda)\b/.test(normalize(p.title))) n-=30;
  if(/leopard|imprime|motif|raye|fleuri|mariniere/.test(normalize(source.title)) && /leopard|imprime|motif|raye|fleuri|mariniere/.test(normalize(p.title)) && kind==='look') n-=25;
  return n;
}
export function select(source,catalog,kind,manual=[],limit=4,excluded=[]) {
  const group=family(source), allowed=kind==='look' ? complementary[group] || [] : [group];
  if(group==='unknown'||group==='jewelry') return [];
  const eligible=catalog.filter(p=>p.available && p.image && p.id!==source.id && !excluded.includes(p.id) && allowed.includes(family(p)));
  const chosen=[];
  for(const id of manual) { const p=eligible.find(x=>x.id===id); if(p&&!chosen.some(x=>x.id===p.id)&&chosen.length<limit) chosen.push(p); }
  const sorted=eligible.slice().sort((a,b)=>score(source,b,kind)-score(source,a,kind)||(b.created||0)-(a.created||0)||a.id-b.id);
  if(kind==='look') for(const category of allowed) {
    if(chosen.length>=limit) break;
    if(chosen.some(p=>family(p)===category)) continue;
    const p=sorted.find(x=>family(x)===category&&!chosen.some(y=>y.id===x.id));
    if(p) chosen.push(p);
  }
  for(const p of sorted) { if(chosen.length>=limit) break; if(!chosen.some(x=>x.id===p.id)) chosen.push(p); }
  return chosen;
}
let catalogPromise;
async function catalog(root) {
  if(!catalogPromise) catalogPromise=(async()=>{
    const items=[]; let page=1, pages=1;
    do {
      const url=new URL(root+'collections/all',location.origin);
      url.searchParams.set('section_id','lcs-style-catalog'); url.searchParams.set('page',String(page));
      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok) throw new Error('Catalogue indisponible');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const data=JSON.parse(doc.querySelector('[data-lcs-catalog]').textContent);
      items.push(...data.products); pages=data.pages; page++;
    } while(page<=pages);
    return items;
  })().catch(error=>{catalogPromise=null;throw error;});
  return catalogPromise;
}
function card(p) {
  const li=document.createElement('li'); li.className='lcs-style__item';
  const a=document.createElement('a'); a.className='lcs-style__link'; a.href=p.url;
  const media=document.createElement('div');media.className='lcs-style__media';
  const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=600;img.height=800;media.append(img);
  const title=document.createElement('h3');title.className='lcs-style__title';title.textContent=p.title;
  const price=document.createElement('span');price.className='lcs-style__price';price.textContent=p.price;
  a.append(media,title,price);li.append(a);return li;
}
async function enhance() {
  const blocks=[...document.querySelectorAll('[data-lcs-auto]:not([data-lcs-ready])')];
  if(!blocks.length) return;
  blocks.forEach(el=>el.dataset.lcsReady='loading');
  try {
    const data=await catalog(blocks[0].dataset.root);
    for(const el of blocks) {
      const source=JSON.parse(el.querySelector('[data-lcs-source]').textContent);
      if(['unknown','jewelry'].includes(family(source))) {el.dataset.lcsReady='manual';continue;}
      const selected=select(source,data,el.dataset.kind,JSON.parse(el.dataset.manual)||[],Number(el.dataset.limit));
      el.querySelector('.lcs-style__grid').replaceChildren(...selected.map(card));
      el.hidden=!selected.length;el.dataset.lcsReady='complete';
    }
  } catch(error) {blocks.forEach(el=>{delete el.dataset.lcsReady;});}
}
if(typeof document!=='undefined') {
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',enhance,{once:true}); else enhance();
  document.addEventListener('shopify:section:load',enhance);
}
